import StackdriverErrorReporter from 'stackdriver-errors-js'

let errorHandler

if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
  const errorReportingAPIKey = 'AIzaSyAi0nVO3eCampvQa3CLW4-NLsv7p9-Bobs'
  errorHandler = new StackdriverErrorReporter()
  errorHandler.start({
    key: errorReportingAPIKey,
    projectId: 'munditrade',
    service: 'landing',
    reportUncaughtExceptions: true,
    reportUnhandledPromiseRejections: true,
  })
} else {
  errorHandler = { report: console.error }
}

export default errorHandler
